import { render, staticRenderFns } from "./AddUnitModal.vue?vue&type=template&id=fab60936&scoped=true&"
import script from "./AddUnitModal.vue?vue&type=script&lang=js&"
export * from "./AddUnitModal.vue?vue&type=script&lang=js&"
import style0 from "./AddUnitModal.vue?vue&type=style&index=0&id=fab60936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab60936",
  null
  
)

export default component.exports